<template>
  <div :style="themeStyle" height="100%">
    <v-row class="headline1_bg p-3" no-gutters>
      <v-col cols="12">
        บทความ
      </v-col>
    </v-row>
    <v-container class="pt-5 pr-0 pl-0" height="100%">
         <v-card
        class="mx-auto rounded-lg"
        v-if="!item"
        elevation="2"
        height="100%"
      >
         <v-skeleton-loader height="100vh"
          type="list-item-three-line, image, article,list-item-three-line, image"
        ></v-skeleton-loader>
      </v-card>
      <v-card
        class="mx-auto rounded-lg"
        v-if="item"
        elevation="2"
        height="100%"
      >
        <v-img class="white--text align-end" :src="item.blogPicture"
        >
        </v-img>
        <v-container fluid>
          <v-row>
              <v-col class="headline1 bold font18">{{item.blogName}}</v-col>
          </v-row>
          <v-row v-if="item.blogSubName">
              <v-col class="bold font14 pt-0"><nl2br tag="p" :text="item.blogSubName" /></v-col>
          </v-row>
          <v-row v-if="item.blogDetails">
              <v-col class="font14"><p  v-html="(item.blogDetails).replace(/<img/g, '<img style=width:100%;height:auto;')"></p></v-col>
          </v-row>
          <v-row v-if="item.blogVideoLink">
              <v-col class="bold font14">
                <p>วิดีโอ บทความ</p>
                <v-card>
                  <video-embed :src="item.blogVideoLink"></video-embed>
                  </v-card>
              </v-col>
          </v-row>
        </v-container>

        <v-card-actions style="background-color:#EEEEEE;">
          <v-btn
            class="rounded-lg headline1"
            text
            block
            @click="$router.push('/blog')"
          >
            กลับหน้า บทความ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'RewardDetail',
  data () {
    return {
      id: this.$route.params.id,
      item: null,
      member: null,
      profile: null,
      loading: true
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted () {
    window.scrollTo(0, 0)
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    await this.getDetailPromotion()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),

    async getDetailPromotion () {
      const result = await this.callBeTaskAPI('get', `/blog/getID?id=${this.id}`)
      if (result) {
        this.item = result
        this.loading = !this.loading
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Blog/Detail.vue